<template>
    <div class="lds-container">
        <div class="clnt-output-lc">
            <template v-if="visibleForm">
                <h1 class="clnt-output-lc__title">
                    Вывод средств
                </h1>
                <form @submit.prevent="outputLC()"
                      class="clnt-output-lc__form">
                    <div class="clnt-output-lc__item clnt-output-lc__control lds-control">
                        <div class="lds-control"
                             :class="{'lds-control_error': $v.debitCard.$error}">
                            <label class="lds-control__label lds-control__label_lg">Карта для выплаты</label>
                            <div class="clnt-output-lc__card-row">
                                <VSelect class="lds-select lds-select_size-md clnt-output-lc__card-select"
                                         id="debitCard"
                                         placeholder="Выберите карту"
                                         v-model="debitCard"
                                         ref="debitCardSelect"
                                         :options="debitCardsOptions"
                                         :append-to-body="true"
                                         :calculate-position="calculateDebitCardDropdownPosition"
                                         label="title">
                                    <template slot="option"
                                              slot-scope="option">
                                        <div class="clnt-output-lc__dropdown-option">
                                            <span class="clnt-output-lc__dropdown-option-title">
                                                {{ option.title }}
                                            </span>
                                            <button type="button"
                                                    class="clnt-output-lc__dropdown-remove-btn"
                                                    aria-label="Удалить карту"
                                                    title="Удалить карту"
                                                    @mousedown.stop.prevent
                                                    @click.stop.prevent="openDeleteDebitCardConfirm(option)">
                                                <SvgIcon name="trash"
                                                         class="clnt-output-lc__dropdown-remove-icon" />
                                            </button>
                                        </div>
                                    </template>
                                    <template #no-options>
                                        Нет доступных карт
                                    </template>
                                    <template #list-footer>
                                        <li class="clnt-output-lc__dropdown-footer">
                                            <button type="button"
                                                    class="clnt-output-lc__dropdown-add-btn"
                                                    @click.stop="addDebitCardModal">
                                                Добавить карту
                                            </button>
                                        </li>
                                    </template>
                                </VSelect>
                                <button type="button"
                                        class="clnt-output-lc__add-card-btn"
                                        @click="addDebitCardModal"
                                        aria-label="Добавить новую карту"
                                        title="Добавить новую карту"
                                        data-tooltip="Добавить новую карту">
                                    <span class="clnt-output-lc__add-card-icon">+</span>
                                </button>
                            </div>
                            <div class="lds-control__message"
                                 v-if="$v.debitCard.$error">
                                Обязательно для заполнения
                            </div>
                        </div>
                    </div>
                    <div class="clnt-output-lc__item clnt-output-lc__cols-sm">
                        <div class="clnt-output-lc__col">
                            <div class="lds-control"
                                 :class="{'lds-control_error': $v.leadsCoins.$error}">
                                <label for="amount-lc"
                                       class="lds-control__label lds-control__label_lg">Сумма в Lead.Coins</label>
                                <div class="lds-control__input lds-control__input_size-md">
                                    <input id="amount-lc"
                                           type="text"
                                           name="leadsCoins"
                                           class="lds-input lds-input_size-md"
                                           placeholder="1 520 000"
                                           v-money="maskCurrency"
                                           v-model.lazy="leadsCoins">
                                    <span class="lds-control__input-symbol">LC</span>
                                </div>
                                <div class="lds-control__message"
                                     v-if="$v.leadsCoins.$error && !$v.leadsCoins.minValue">
                                    Минимальная сумма вывода 1 520 000 LC
                                </div>
                                <div class="lds-control__message"
                                     v-if="$v.leadsCoins.$error && !$v.leadsCoins.maxValue">
                                    Максимальная сумма вывода {{ formatCoins(accountBalance) }} LC
                                </div>
                                <div class="lds-control__message"
                                     v-if="$v.leadsCoins.$error && !$v.leadsCoins.required">
                                    Обязательно для заполнения
                                </div>
                            </div>
                        </div>
                        <div class="clnt-output-lc__col">
                            <div class="lds-control">
                                <label for="amout-rub"
                                       class="lds-control__label lds-control__label_lg">Сумма в рублях</label>
                                <div class="lds-control__input lds-control__input_size-md">
                                    <input id="amout-rub"
                                           type="text"
                                           name="sumRub"
                                           class="lds-input lds-input_size-md"
                                           v-model.lazy="convertedRub"
                                           v-money="maskCurrencyDecimal"
                                           disabled>
                                    <SvgIcon name="leads-coins"
                                             v-if="!!currentEasterEgg && currentEasterEgg.needShow && showEgg"
                                             @click.native="collectEasterEgg"
                                             class="clnt-output-lc__easter-icon" />
                                    <span class="lds-control__input-symbol">₽</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clnt-output-lc__checkbox">
                        <div class="lds-control"
                             :class="{'lds-control_error': $v.agreement.$error}">
                            <div class="lds-checkbox lds-checkbox_sm">
                                <input type="checkbox"
                                       id="agreement"
                                       v-model="agreement"
                                       name="agreement"
                                       class="lds-checkbox__checkbox">
                                <label class="lds-checkbox__label"
                                       for="agreement">
                                    Я подтверждаю, что ознакомлен с правилами и ограничениями получения выплат и согласен с этими условиями.
                                </label>
                            </div>
                            <div class="lds-control__message"
                                 v-if="$v.agreement.$error">
                                Обязательно для заполнения
                            </div>
                        </div>
                        <div class="lds-control"
                             :class="{'lds-control_error': $v.agreementPersonal.$error}">
                            <div class="lds-checkbox lds-checkbox_sm">
                                <input type="checkbox"
                                       id="agreement-two"
                                       v-model="agreementPersonal"
                                       name="agreement"
                                       class="lds-checkbox__checkbox">
                                <label class="lds-checkbox__label"
                                       for="agreement-two">
                                    С правилами обработки персональных данных в
                                    <router-link :to="{name: 'Agreement'}">условиях работы</router-link>
                                    ознакомлен и согласен.*
                                </label>
                            </div>
                            <div class="lds-control__message"
                                 v-if="$v.agreementPersonal.$error">
                                Обязательно для заполнения
                            </div>
                        </div>
                    </div>

                    <div class="clnt-output-lc__button">
                        <button class="lds-btn lds-btn_fill lds-btn_size-xs -blue"
                                type="submit"
                                :disabled="disableSubmit">
                            Отправить заявку
                        </button>
                    </div>
                </form>
            </template>
            <div v-else
                 class="clnt-output-lc__success">
                <span class="clnt-output-lc__success-ico" />
                <div class="clnt-output-lc__title">
                    Готово!
                </div>
                <p class="clnt-output-lc__success-text">
                    Запрос на выплату {{ convertedRub }} ₽ на карту {{ selectedDebitCardLastNumbers }} принят
                </p>
                <button class="lds-btn lds-btn_size-xs lds-btn_fill -gray"
                        @click="showForm()">
                    Отправить новую заявку
                </button>
            </div>
            <v-easy-dialog v-model="deleteDebitCardDialogModel">
                <div>
                    <div class="clnt-output-lc__dialog">
                        <button type="button"
                                class="clnt-output-lc__dialog-close"
                                :disabled="processing"
                                @click="closeDeleteDebitCardConfirm">
                            <SvgIcon name="close" />
                        </button>
                        <div class="clnt-output-lc__dialog-title">
                            Удалить карту?
                        </div>
                        <div class="clnt-output-lc__dialog-text">
                            Карта будет удалена из списка карт для выплаты.
                        </div>
                        <div class="clnt-output-lc__dialog-card">
                            {{ pendingDeleteDebitCardTitle }}
                        </div>
                        <div class="clnt-output-lc__dialog-actions">
                            <button type="button"
                                    class="lds-btn lds-btn_fill lds-btn_size-sm -gray"
                                    :disabled="processing"
                                    @click="closeDeleteDebitCardConfirm">
                                Отмена
                            </button>
                            <button type="button"
                                    class="lds-btn lds-btn_fill lds-btn_size-sm clnt-output-lc__dialog-delete-btn"
                                    :disabled="processing"
                                    @click="confirmDebitCardDelete">
                                Удалить
                            </button>
                        </div>
                    </div>
                </div>
            </v-easy-dialog>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations,
    mapState,
} from 'vuex';
import {required, minValue, maxValue} from 'vuelidate/lib/validators';
import {VMoney} from 'v-money';
import _debounce from 'lodash/debounce';
import vSelect from 'vue-select';
import VEasyDialog from 'v-easy-dialog';
import formattingCoins from '@/mixins/formattingCoins';
import {tour2egg2} from '@/models/EasterEggs/EasterEgg';
import SvgIcon from '@/components/common/SvgIcon';
import {watchSelectDropdownPositionByComponent} from '@/utils/selectDropdownPosition';

export default {
    name: 'OutputLC',
    components: {
        SvgIcon,
        vSelect,
        VEasyDialog,
    },
    directives: {
        money: VMoney,
    },
    mixins: [
        formattingCoins,
    ],
    data: () => ({
        maskCurrency: {
            thousands: ' ',
            precision: 0,
        },
        maskCurrencyDecimal: {
            decimal: '.',
            thousands: ' ',
            precision: 2,
        },
        debitCard: null,
        leadsCoins: 0,
        convertedRub: 0,
        agreement: false,
        agreementPersonal: false,
        minValueLC: 1520000,
        visibleForm: true,
        showEgg: false,
        deleteDebitCardConfirmVisible: false,
        pendingDeleteDebitCard: null,
    }),
    computed: {
        ...mapState('account', [
            'accountBalance',
        ]),
        ...mapState('outputLC', [
            'debitCards',
            'rubAmount',
            'processing',
        ]),
        ...mapGetters('easterEggs', [
            'getAvailable',
        ]),
        disableSubmit() {
            return this.processing;
        },
        debitCardsOptions() {
            return this.debitCards.map(card => ({
                ...card,
                title: `${card.cardNumber} ${card.cardExpireMonth}/${card.cardExpireYear}`,
            }));
        },
        selectedDebitCardLastNumbers() {
            const number = this.debitCard && this.debitCard.cardNumber;
            if (number) {
                const lastNumbers = number.replace(/\s+/g, '').substr(-4);
                return `····${lastNumbers}`;
            }
            return '';
        },
        currentEasterEgg() {
            return this.getAvailable(tour2egg2);
        },
        pendingDeleteDebitCardTitle() {
            return this.pendingDeleteDebitCard ? this.pendingDeleteDebitCard.title : '';
        },
        deleteDebitCardDialogModel: {
            get() {
                return this.deleteDebitCardConfirmVisible;
            },
            set(value) {
                if (value) {
                    this.deleteDebitCardConfirmVisible = true;
                    return;
                }

                if (!this.processing) {
                    this.closeDeleteDebitCardConfirm();
                }
            },
        },
    },
    watch: {
        rubAmount(value) {
            this.convertedRub = value;

            if (Number(value) > 0) {
                this.debounce_checkEgg(tour2egg2);
            }
        },
        leadsCoins(newValue, oldValue) {
            const number = newValue.toString().replace(/\s+/g, '');
            if (Number(number) < 2 ** 32) {
                this.debounce_inputLC(number);
            } else {
                this.leadsCoins = oldValue;
            }
        },
    },
    created() {
        this.getDebitCards();
    },
    validations: {
        debitCard: {
            required,
        },
        leadsCoins: {
            required,
            minValue(value) {
                const number = value ? value.replace(/\s+/g, '') : 0;
                return minValue(this.minValueLC)(number);
            },
            maxValue(value) {
                const number = value ? value.replace(/\s+/g, '') : 0;
                return maxValue(this.accountBalance)(number);
            },
        },
        agreement: {
            checkAgreement: value => value === true,
        },
        agreementPersonal: {
            checkAgreementPersonal: value => value === true,
        },
    },
    beforeMount() {
        const context = this;
        this.debounce_inputLC = _debounce(this.convertLeadsCoins, 500);
        this.debounce_checkEgg = _debounce(code => context.check(code).then(() => { context.showEgg = true; }), 500);
    },
    beforeDestroy() {
        if (this.debounce_inputLC && this.debounce_inputLC.cancel) {
            this.debounce_inputLC.cancel();
        }

        if (this.debounce_checkEgg && this.debounce_checkEgg.cancel) {
            this.debounce_checkEgg.cancel();
        }
    },
    destroyed() {
        this.$v.$reset();
    },
    methods: {
        ...mapActions('account', [
            'loadBalance',
        ]),
        ...mapActions('outputLC', [
            'getDebitCards',
            'getConvertSum',
            'outputSum',
            'deleteDebitCard',
        ]),
        ...mapMutations('outputLC', [
            'setRubAmount',
        ]),
        ...mapActions('easterEggs', [
            'check',
            'collect',
        ]),
        async outputLC() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            const data = {
                debitCardId: this.debitCard.id,
                leadsCoins: Number(this.leadsCoins.replace(/\s+/g, '')),
                agreement: this.agreement,
                agreementPersonal: this.agreementPersonal,
            };
            const result = await this.outputSum(data);
            if (result) {
                this.loadBalance();
                this.visibleForm = false;
            }
        },
        formatFixed(value) {
            return parseFloat(value).toFixed(2);
        },
        addDebitCardModal() {
            this.$router.push({
                name: 'CreateDebitCard',
            });
        },
        openDeleteDebitCardConfirm(option) {
            this.pendingDeleteDebitCard = option;
            this.deleteDebitCardConfirmVisible = true;

            if (this.$refs.debitCardSelect && typeof this.$refs.debitCardSelect.closeSearchOptions === 'function') {
                this.$refs.debitCardSelect.closeSearchOptions();
            }
        },
        closeDeleteDebitCardConfirm() {
            if (this.processing) {
                return;
            }

            this.resetDeleteDebitCardConfirm();
        },
        resetDeleteDebitCardConfirm() {
            this.deleteDebitCardConfirmVisible = false;
            this.pendingDeleteDebitCard = null;
        },
        async confirmDebitCardDelete() {
            if (!this.pendingDeleteDebitCard) {
                return;
            }

            const deletedDebitCardId = this.pendingDeleteDebitCard.id;
            const result = await this.deleteDebitCard(deletedDebitCardId);

            if (!result) {
                return;
            }

            if (this.debitCard && this.debitCard.id === deletedDebitCardId) {
                this.debitCard = null;
            }

            this.resetDeleteDebitCardConfirm();
            await this.getDebitCards();
        },
        calculateDebitCardDropdownPosition(dropdownList, component) {
            return watchSelectDropdownPositionByComponent(
                dropdownList,
                component,
                list => {
                    list.style.overflowX = 'hidden';
                },
            );
        },
        showForm() {
            this.visibleForm = true;

            this.debitCard = null;
            this.leadsCoins = 0;
            this.setRubAmount(0);
            this.agreement = false;
            this.agreementPersonal = false;
            this.$v.$reset();
        },
        convertLeadsCoins(number) {
            this.getConvertSum(number);
        },
        collectEasterEgg() {
            this.collect(this.currentEasterEgg);
        },
    },
};
</script>

<style scoped>
.clnt-output-lc__control {
    width: 100%;
    max-width: none;
}

.clnt-output-lc__cols-sm {
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.clnt-output-lc__col {
    max-width: none;
    min-width: 0;
}

.clnt-output-lc__card-row {
    display: flex;
    align-items: stretch;
    gap: 12px;
    width: 100%;
}

.clnt-output-lc__card-select {
    flex: 1 1 auto;
}

.clnt-output-lc__add-card-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    margin-top: auto;
    border: 1px solid #d6dde8;
    border-radius: 10px;
    background-color: #fff;
    color: #3273dc;
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease;
}

.clnt-output-lc__add-card-btn:hover,
.clnt-output-lc__add-card-btn:focus {
    border-color: #3273dc;
    box-shadow: 0 0 0 3px rgba(50, 115, 220, 0.12);
    outline: none;
}

.clnt-output-lc__add-card-btn:hover::after,
.clnt-output-lc__add-card-btn:focus::after {
    content: attr(data-tooltip);
    position: absolute;
    left: 50%;
    bottom: calc(100% + 8px);
    transform: translateX(-50%);
    padding: 6px 10px;
    border-radius: 8px;
    background-color: #303446;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
    white-space: nowrap;
    pointer-events: none;
    z-index: 2;
}

.clnt-output-lc__add-card-icon {
    font-size: 24px;
    line-height: 1;
}

.clnt-output-lc__dropdown-footer {
    position: sticky;
    bottom: -24px;
    margin: 8px -16px -24px;
    padding: 8px 16px 16px;
    border-top: 1px solid #edf1f6;
    list-style: none;
    background-color: #fff;
    box-shadow: 0 -6px 14px rgba(29, 36, 56, 0.08);
    z-index: 1;
}

.clnt-output-lc__dropdown-add-btn {
    display: block;
    width: 100%;
    padding: 8px 10px;
    border: 0;
    border-radius: 8px;
    background-color: #f4f8ff;
    color: #3273dc;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
}

.clnt-output-lc__dropdown-add-btn:hover,
.clnt-output-lc__dropdown-add-btn:focus {
    background-color: #e8f0ff;
    outline: none;
}

.clnt-output-lc__dropdown-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.clnt-output-lc__dropdown-option-title {
    min-width: 0;
    flex: 1 1 auto;
}

.clnt-output-lc__dropdown-remove-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: static;
    width: 24px;
    height: 24px;
    flex: 0 0 24px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #77839a;
    cursor: pointer;
    line-height: 0;
    opacity: 1;
}

.clnt-output-lc__dropdown-remove-icon {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
}

.clnt-output-lc__dropdown-remove-btn:hover,
.clnt-output-lc__dropdown-remove-btn:focus {
    color: #d04a57;
    opacity: 1;
    outline: none;
}

.clnt-output-lc__dialog {
    position: relative;
    width: 100%;
    max-width: 420px;
    padding: 28px 28px 24px;
    border-radius: 16px;
    background-color: #fff;
}

.clnt-output-lc__dialog-close {
    position: absolute;
    top: 18px;
    right: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: 1px solid #e1e7f0;
    border-radius: 50%;
    background: #f8fafc;
    color: #5b6475;
    cursor: pointer;
    line-height: 0;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.clnt-output-lc__dialog-close ::v-deep .lds-icon {
    width: 16px;
    height: 16px;
}

.clnt-output-lc__dialog-close:hover,
.clnt-output-lc__dialog-close:focus {
    background: #eef4ff;
    border-color: #bfd1f3;
    color: #1f2a44;
    transform: translateY(-1px);
    outline: none;
}

.clnt-output-lc__dialog-close:focus-visible {
    box-shadow: 0 0 0 3px rgba(50, 115, 220, 0.12);
}

.clnt-output-lc__dialog-close:disabled {
    opacity: 0.5;
    cursor: default;
}

.clnt-output-lc__dialog-title {
    margin-bottom: 15px;
    color: #1f2a3d;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    cursor: default;
    user-select: none;
    caret-color: transparent;
}

.clnt-output-lc__dialog-text {
    margin-bottom: 14px;
    color: #667085;
    font-size: 14px;
    line-height: 1.5;
    cursor: default;
    user-select: none;
    caret-color: transparent;
}

.clnt-output-lc__dialog-card {
    margin-bottom: 20px;
    padding: 12px 14px;
    border-radius: 10px;
    background-color: #f5f7fb;
    color: #1f2a3d;
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;
    cursor: default;
    user-select: none;
    caret-color: transparent;
}

.clnt-output-lc__dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.clnt-output-lc__dialog-delete-btn {
    background-color: #d04a57;
    border-color: #d04a57;
}

.clnt-output-lc__dialog-delete-btn:hover,
.clnt-output-lc__dialog-delete-btn:focus {
    background-color: #bf3d4a;
    border-color: #bf3d4a;
}

.clnt-output-lc__dialog-delete-btn:disabled {
    background-color: #d04a57;
    border-color: #d04a57;
}

@media (max-width: 767px) {
    .clnt-output-lc__card-row {
        gap: 10px;
    }

    .clnt-output-lc__add-card-btn {
        width: 34px;
        height: 34px;
    }

    .clnt-output-lc__dialog {
        padding: 24px 20px 20px;
    }

    .clnt-output-lc__dialog-title {
        font-size: 20px;
    }

    .clnt-output-lc__dialog-actions {
        flex-direction: column-reverse;
    }
}
</style>
